import {Component, OnInit} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DataHandlerService} from '../../../services/data-handler.service';
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-broker-notes',
    templateUrl: 'broker-notes.component.html',
    standalone: true,
  imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatInputModule, MatFormFieldModule, NgIf]
})
export class BrokerNotesComponent extends WizardWidgetComponent implements OnInit {

  constructor(public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.ndiDataSubscription();
  }

  ndiDataSubscription() {
    this.dataHandlerService.getNdiPassFlag()
      .subscribe((ndiPass: boolean) => {
        console.log('getNdiPassFlag', ndiPass);

        if (ndiPass) {
          this.formGroup.get('notes').clearValidators();
        } else {
          this.formGroup.get('notes').setValidators(Validators.required);
        }
        this.formGroup.get('notes').markAsTouched();
        this.formGroup.get('notes').updateValueAndValidity();
      });
  }
}
